module.exports = __webpack_public_path__ + "static/private_office_4-f3a9f28bf6a3d5412ad30a389104c287.webp";